import { useEffect, useState } from 'react'
import consoleLogger from '../../modules/console-logger'
import { hasEventHappened } from '../../bundles/BundleScriptScheduler'

const [consoleLog] = consoleLogger('SourcePoint')

const usePianoReady = () => {
  const [pianoReady, setPianoReady] = useState(false)

  useEffect(() => {
    window.refreshAds = () => {
      consoleLog('Debugging', 'refreshAds - ' + hasEventHappened('pianoLoaded'))
      setPianoReady(hasEventHappened('pianoLoaded') === true)
      consoleLog('Debugging', 'refreshed')
    }
  }, [])
  consoleLog('piano ready state?', pianoReady)
  return pianoReady
}

export default usePianoReady
